<script setup lang="ts">
import { capitalize, computed } from "vue";

import { colorsByTheme } from "~/constants/style";
import { MoveIcon } from "~/icons";
import { usePageStore } from "~/stores";
import { getItemCountText } from "~/utils/common";

const props = defineProps<{
  count: number;
}>();

const pageStore = usePageStore();

const colors = computed(() => colorsByTheme[pageStore.theme]);
const text = computed(() => capitalize(getItemCountText(props.count, "task")));
</script>

<template>
  <div
    class="flex w-max flex-row items-center gap-1 rounded-sm border px-2.5 py-1.5 text-sm opacity-100"
    :style="{ backgroundColor: colors.bgLt, color: colors.textMd, borderColor: colors.borderLt }">
    <MoveIcon class="size-4 text-vlt" />
    <div>{{ text }}</div>
  </div>
</template>
